export const BOOK_ENDPOINT = 'winter-service/book'

// The book itself. It answers with the PDF rather than with a link to one, so it is
// asked for as a blob and handed to the browser as a download.
export const buildBookPdfEndpoint = (bookId) => `${BOOK_ENDPOINT}/${bookId}/pdf`

// A book is assembled out of the task catalogue - only tasks may go into one, never
// incoming requests and never work orders - so the picking table reads the tasks
// listing itself.
export const TASKS_ENDPOINT = 'winter-service-tasks'

export const BOOK_TABLE_KEY = 'winter-service-v2-book'
export const BOOK_UI_VIEW = 'winter_service2_book'

// The picking table is a table of its own: it lists tasks, not books, so it keeps its
// own column layout rather than sharing the book listing's.
export const BOOK_TASKS_TABLE_KEY = 'winter-service-v2-book-tasks'
export const BOOK_TASKS_UI_VIEW = 'winter_service2_book_tasks'

export const BOOK_INDEX_ROUTE = 'WinterService2Book'

export const BOOK_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/book'
